import { useSelector } from 'react-redux';
import screenFinder from '../../../../../constants/screens/screenFinder';
import screensSteps from '../../../../../constants/screens/screensSteps';
import GlobalSubTopBar from '../../../../../utils/components/GlobalSubTopBar';

function CreateCtaTopBar({ isAgentScreen = false, onAgentScreenBack }) {
  const currentStep = useSelector(state => state.cta.etc.ctaStep);
  const data = screenFinder('cta');
  const creationType = useSelector(state => state.cta.etc.creationType);

  return (
    <GlobalSubTopBar
      data={data}
      currentStep={currentStep}
      backRoute={data.dashboardPath}
      steps={screensSteps}
      creationType={creationType}
      isAgentScreen={isAgentScreen}
      onAgentScreenBack={onAgentScreenBack}
    />
  );
}

export default CreateCtaTopBar;
